import { parse } from 'query-string';
import { includes } from 'lodash-es';
import dayjs from '@api/services/tools/dayjs';
import { SHORT_DATE_FORMAT, TIME_RANGES } from '@api/services/constants';
import { DateDropdownOptions } from '@api/services/dictionaries/DateRangeValues';

export const getDateDropdownValue = (
    shouldReturnTimeRangeString: boolean,
    defaultValue: string | number = DateDropdownOptions.All,
    timeRanges?: number[]
): number | string => {
    const query = parse(location.search);
    const timeRangesValues = timeRanges ? timeRanges : TIME_RANGES;

    if (!query.from) return defaultValue;

    if (query.from && query.to) {
        const from = dayjs(query.from as string, SHORT_DATE_FORMAT);
        const to = dayjs(query.to as string, SHORT_DATE_FORMAT);
        const datesDiff = to.diff(from, 'day');

        if (includes(timeRangesValues, datesDiff) && dayjs().isSame(to, 'day')) {
            return shouldReturnTimeRangeString ? datesDiff.toString() : datesDiff;
        } else {
            return DateDropdownOptions.Calendar;
        }
    }

    return defaultValue;
};

export const getDateDropdownLabel = (defaultValue?: string): string => {
    const query = parse(location.search);
    const dateRange = query?.daterange?.toString();

    const labels = {
        '7': 'last7days',
        '14': 'last14days',
        '30': 'last30days',
        '90': 'last3months',
        '180': 'last6months',
        '365': 'lastyear',
    };

    if (dateRange && dateRange !== DateDropdownOptions.Calendar) return dateRange;

    if (query.from && query.to) {
        const from = dayjs(query.from as string, SHORT_DATE_FORMAT);
        const to = dayjs(query.to as string, SHORT_DATE_FORMAT);
        const datesDiff = to.diff(from, 'day');

        if (includes(TIME_RANGES, datesDiff) && dayjs().isSame(to, 'day')) {
            return labels[datesDiff.toString()];
        } else {
            return DateDropdownOptions.Calendar;
        }
    }

    return defaultValue;
};
